var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b',[_vm._v("Classified sources")]),_c('area-classified-source-table',{attrs:{"area":_vm.area}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }